module.exports = __webpack_public_path__ + "img/icon-invoice-ad-placeholder.27b0eff7.png";